module.exports = __webpack_public_path__ + "assets/ergIcon1.8b92bb51.svg";